import React from "react"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ApiService from "../../../../../services/ApiService"
import Typography from "@mui/material/Typography"

export type TakeStateCountsDTO = {
    not_started: number,
    in_progress: number,
    completed: number,
    graded: number,
    total: number,

    /** Not Rateable is not part of the TakeStateEnum and may overlap with other Take States.
     *  Not Rateable counts will are not included in the Total. */
    not_rateable: number
}

const ITEM_WIDTH = "200px"

export function TakeStateCounts({statusCounts}: { statusCounts: TakeStateCountsDTO }) {

    return (
        <List>
            <ListItem sx={{display: "flex", justifyContent: "space-between", maxWidth: ITEM_WIDTH}} divider>
                <Typography variant={"body1"}>{"Not Started"}</Typography>
                <Typography variant={"body1"}>{statusCounts.not_started}</Typography>
            </ListItem>
            <ListItem sx={{display: "flex", justifyContent: "space-between", maxWidth: ITEM_WIDTH}} divider>
                <Typography variant={"body1"}>{"In Progress"}</Typography>
                <Typography variant={"body1"}>{statusCounts.in_progress}</Typography>
            </ListItem>
            <ListItem sx={{display: "flex", justifyContent: "space-between", maxWidth: ITEM_WIDTH}} divider>
                <Typography variant={"body1"}>{"Completed"}</Typography>
                <Typography variant={"body1"}>{statusCounts.completed}</Typography>
            </ListItem>
            <ListItem sx={{display: "flex", justifyContent: "space-between", maxWidth: ITEM_WIDTH}} divider>
                <Typography variant={"body1"}>{"Graded"}</Typography>
                <Typography variant={"body1"}>{statusCounts.graded}</Typography>
            </ListItem>
            <ListItem sx={{display: "flex", justifyContent: "space-between", maxWidth: ITEM_WIDTH}} divider>
                <Typography variant={"body1"}>{"Total"}</Typography>
                <Typography variant={"body1"}>{statusCounts.total}</Typography>
            </ListItem>
            <ListItem sx={{display: "flex", justifyContent: "space-between", maxWidth: ITEM_WIDTH}} divider>
                <Typography variant={"body1"}>{"Not Rateable"}</Typography>
                <Typography variant={"body1"}>{statusCounts.not_rateable}</Typography>
            </ListItem>
        </List>
    )
}

export async function fetchTakeStateCounts(groupId: number): Promise<TakeStateCountsDTO> {
    const response = await ApiService.get(`${ApiService.API_URL}takes/${groupId}/take-status-counts`)
    return response.data
}